export default "__VITE_ASSET__DuYhXpQW__"